import { AppContext } from '@prisjakt/ui-app-context';
import React, { useContext } from 'react';
import Currency from '@prisjakt/ui-currency';
import SparkLine from '@prisjakt/ui-sparkline';
import Rating from '@prisjakt/ui-rating';
import { StyledCoreProperties, TabSubtitle } from './styles';
import { ProductNavigationLink } from '../styles';
import { IBaseLink } from './types';

export const ProductNavigationMainLink: React.FC<IBaseLink> = props => {
  const { t } = useContext(AppContext);
  const { product } = props;
  if (!product) {
    return null;
  }

  return (
    <ProductNavigationLink data-test="TabButton" data-test-section="main">
      <span>{t('product', 'tabs.prices')}</span>
      <TabSubtitle>
        <span>
          {product.priceSummary && (
            <Currency
              price={
                product.priceSummary.regular || product.priceSummary.alternative
              }
            />
          )}
        </span>
      </TabSubtitle>
    </ProductNavigationLink>
  );
};

export const ProductNavigationPropertiesLink: React.FC<IBaseLink> = props => {
  const { t } = useContext(AppContext);
  const { product } = props;

  if (!product) {
    return null;
  }

  return (
    <ProductNavigationLink data-test="TabButton" data-test-section="properties">
      <span>{t('product', 'tabs.properties')}</span>
      <TabSubtitle>
        {product.coreProperties && product.coreProperties.nodes && (
          <StyledCoreProperties
            toneDown
            size="tiny"
            maxrows={2}
            properties={product.coreProperties.nodes
              .map(node => node.pretty || '')
              .filter(Boolean)}
          />
        )}
      </TabSubtitle>
    </ProductNavigationLink>
  );
};

export const ProductNavigationReviewsLink: React.FC<IBaseLink> = props => {
  const { t } = useContext(AppContext);
  const { product } = props;

  if (!product) {
    return null;
  }

  return (
    <ProductNavigationLink data-test="TabButton" data-test-section="reviews">
      <span>{t('product', 'tabs.reviews')}</span>
      <TabSubtitle>
        {product.userReviewSummary &&
        product.userReviewSummary.count &&
        product.userReviewSummary.count > 0 ? (
          <Rating
            rate={product.userReviewSummary.rating}
            count={product.userReviewSummary.count}
            size="small"
            showRate
            showCounterAs="number"
            showRateAs="number"
          />
        ) : null}
      </TabSubtitle>
    </ProductNavigationLink>
  );
};

export const ProductNavigationHistoryLink: React.FC<IBaseLink> = props => {
  const { t } = useContext(AppContext);
  const { product } = props;

  if (!product) {
    return null;
  }

  return (
    <ProductNavigationLink data-test="TabButton" data-test-section="statistics">
      <span>{t('product', 'tabs.price-history')}</span>
      <TabSubtitle>
        {product.sparkline && product.sparkline.values && (
          <SparkLine
            width={100}
            height={10}
            values={product.sparkline.values}
            disableAnimation
          />
        )}
      </TabSubtitle>
    </ProductNavigationLink>
  );
};
